<template>
	<div class="themed-tabs">
		<!-- Tab Navigation -->
		<div class="themed-tabs__nav" :class="navClass">
			<button
				v-for="tab in tabs"
				:key="tab.value"
				class="themed-tabs__tab"
				:class="{ 'themed-tabs__tab--active': value === tab.value }"
				@click="handleTabClick(tab.value)"
				:disabled="tab.disabled"
				:aria-selected="value === tab.value"
				role="tab"
			>
				<span class="themed-tabs__tab-label">{{ tab.label }}</span>
				<span v-if="tab.count !== undefined" class="themed-tabs__tab-count">
					{{ tab.count }}
				</span>
			</button>
		</div>

		<!-- Tab Content -->
		<div class="themed-tabs__content">
			<!-- If using component-based tabs -->
			<component
				v-if="activeTabConfig && activeTabConfig.component"
				:is="activeTabConfig.component"
				v-bind="activeTabConfig.props || {}"
			/>
			
			<!-- If using slot-based tabs (backward compatible) -->
			<slot v-else :active-tab="value" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'ThemedTabs',
	
	props: {
		// v-model binding for active tab (Vue 2 uses 'value')
		value: {
			type: [String, Number],
			required: true
		},
		
		// Array of tab configurations
		// Example: [
		//   { label: 'Tab 1', value: 'tab1', count: 5, disabled: false, component: MyComponent, props: {} }
		// ]
		tabs: {
			type: Array,
			required: true,
			validator: (tabs) => {
				return tabs.every(tab => 
					tab.label !== undefined && 
					tab.value !== undefined
				);
			}
		},
		
		// Additional CSS class for nav container
		navClass: {
			type: String,
			default: ''
		},
		
		// Variant style
		variant: {
			type: String,
			default: 'default',
			validator: (value) => ['default', 'pills', 'underline'].includes(value)
		}
	},
	
	emits: ['input', 'tab-change'],
	
	computed: {
		activeTabConfig() {
			return this.tabs.find(tab => tab.value === this.value);
		}
	},
	
	methods: {
		handleTabClick(value) {
			if (this.value !== value) {
				this.$emit('input', value);
				this.$emit('tab-change', value);
			}
		}
	}
}
</script>
